export default "__VITE_ASSET__7a346b4a__"